"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var _default = (0, _react.createContext)({
  title: '',
  adults: 0,
  children: 0,
  rooms: 0,
  nights: 0,
  nightlyPrice: null,
  strikethroughPrice: null,
  dueAtHotelPrice: null,
  payNowPrice: null,
  grandTotal: null,
  savedAmount: null,
  taxes: null,
  resortFees: null,
  hotelFees: null,
  insuranceFees: null,
  rateProviderText: null,
  benefits: {
    iconName: null,
    title: null,
    perks: []
  },
  footnotes: {
    exclusiveDeal: null,
    estimatedCurrency: null,
    payNow: null,
    dueAtHotel: null
  }
});

exports["default"] = _default;